import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://iqkrxiioknglvrybdxlh.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlxa3J4aWlva25nbHZyeWJkeGxoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc0MDcyMjMsImV4cCI6MjA4Mjk4MzIyM30.7AE-hmPOFI5UAw75t4QIKwFzZee9_XsE9dFDy9fn63s';

const customSupabaseClient = createClient(supabaseUrl, supabaseAnonKey);

export default customSupabaseClient;

export { 
    customSupabaseClient,
    customSupabaseClient as supabase,
};
